import { render } from "./annualLossCom.vue?vue&type=template&id=04d59104&scoped=true"
import script from "./annualLossCom.vue?vue&type=script&lang=js"
export * from "./annualLossCom.vue?vue&type=script&lang=js"

import "./annualLossCom.vue?vue&type=style&index=0&id=04d59104&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d59104"]])

export default __exports__